import env from 'utils/functions/env';

export const isRecaptchaEnabled = () => {
    return 1 === parseInt(env('FEATURE_FLAG_RECAPTCHA'));
};
